import { render } from "./ErrorDialog.vue?vue&type=template&id=1a88d042"
import script from "./ErrorDialog.vue?vue&type=script&lang=ts"
export * from "./ErrorDialog.vue?vue&type=script&lang=ts"

import "./ErrorDialog.vue?vue&type=style&index=0&id=1a88d042&lang=scss"
script.render = render

export default script